import { Fade, Slide } from "react-slideshow-image";
import styles from "./Carousel.module.scss";
import { MdOutlineArrowBackIos } from "react-icons/md";
import { MdOutlineArrowForwardIos } from "react-icons/md";
import { ReactNode } from "react";
import classNames from "classnames";

export const Carousel: React.FC<{
  className?: string;
  slides: ReactNode[];
  settings?: Partial<Parameters<typeof Slide>[0]>;
  type?: "slide" | "fade";
}> = ({ settings, slides, className, type = "slide" }) => {
  const Element = type === "fade" ? Fade : Slide;
  return (
    <div className={classNames(styles.root, className)}>
      <Element
        prevArrow={
          <button>
            <MdOutlineArrowBackIos size="2rem" />
          </button>
        }
        nextArrow={
          <button>
            <MdOutlineArrowForwardIos size="2rem" />
          </button>
        }
        transitionDuration={200}
        autoplay={false}
        indicators={indicators}
        {...settings}
      >
        {slides.map((slide, index) => (
          <div key={index} className={styles.slide}>
            {slide}
          </div>
        ))}
      </Element>
    </div>
  );
};

const indicators: Parameters<typeof Slide>[0]["indicators"] = (index) => (
  <div className={styles.indicator}></div>
);
